export default "__VITE_ASSET__22806a65__"